import { DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";
import { LinkUtils } from "@core/layout/utils/link.utils";
import { SideNavItem } from "@core/layout/components/side-nav/models/side-nav-item.model";
import { SideNavIds } from "@core/layout/components/side-nav/enums/side-nav-ids.enum";

export const SIDE_NAV_ADMIN_MARKET_ITEMS: SideNavItem[] = [
	{
		id: SideNavIds.ACCUEIL,
		icon: "home-alt",
		label: "Accueil",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, DojoRoutesEnum.DASHBOARD),
	},
	{
		id: SideNavIds.PUBLICITES,
		icon: "comment-alt-image",
		label: "Publicité",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
			DojoRoutesEnum.ADMIN_MARKET,
			DojoRoutesEnum.PUBLICITES,
		]),
	},
	{
		id: SideNavIds.INFO_DU_MOMENT,
		icon: "info-circle",
		label: "Info du moment",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
			DojoRoutesEnum.ADMIN_MARKET,
			DojoRoutesEnum.INFO_DU_MOMENT,
		]),
	},
	{
		id: SideNavIds.ALERTES,
		icon: "exclamation-triangle",
		label: "Alerte",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [DojoRoutesEnum.ADMIN_MARKET, DojoRoutesEnum.ALERTES]),
	},
];
